import React from 'react'
  
export default function Page1() {
    return (
        <div>
            <h1>About</h1>
        </div>
    )
}